import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var modules_e0508c7c = {
  "responsive": "Img_module_responsive__e0e919b3"
};
var _excluded = ["renderImage"],
    _excluded2 = ["className", "wrapperClassName", "src", "source", "alt", "title", "autoResponsive"];

var Img = function Img(_ref) {
  var renderImage = _ref.renderImage,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (typeof renderImage === "function") {
    return renderImage({
      props: props
    });
  }

  var className = props.className,
      wrapperClassName = props.wrapperClassName,
      src = props.src,
      source = props.source,
      alt = props.alt,
      title = props.title,
      autoResponsive = props.autoResponsive,
      restProps = _objectWithoutPropertiesLoose(props, _excluded2);

  if (src) {
    return /*#__PURE__*/React.createElement("img", _extends({
      className: classnames(autoResponsive && modules_e0508c7c.responsive, wrapperClassName),
      src: src,
      alt: alt,
      title: title
    }, restProps));
  }

  if (source) {
    return /*#__PURE__*/React.createElement("picture", restProps, /*#__PURE__*/React.createElement("source", {
      srcSet: source.srcSet,
      sizes: source.sizes
    }), /*#__PURE__*/React.createElement("img", _extends({
      className: classnames(autoResponsive && modules_e0508c7c.responsive, wrapperClassName),
      src: source.src,
      srcSet: source.srcSet,
      sizes: source.sizes,
      alt: alt,
      title: title
    }, restProps)));
  }

  console.error("Img requires either src or source as a prop");
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

Img.defaultProps = {
  className: undefined,
  wrapperClassName: undefined,
  src: undefined,
  source: undefined,
  title: undefined,
  autoResponsive: true,
  renderImage: undefined
};
export default Img;
export { Img };